<div class="bmc-uipath-detail-wrapper" *ngIf="!(isLoading$ | async) &&  uiPathConnection$ | async as uiPathConnection">
    <uipath-configuration [uiPathOriginalConnection]="uiPathOriginalConnection" [botDetail]="uiPathConnection" (save)="onSave($event)" (testConnection)="onTestConnection($event)" #botConfiguration    
    [enableClientCredOnPremiseUipath]="enableClientCredOnPremiseUipath">
    </uipath-configuration>
    <hr class="bmc-bot-detail-wrapper__horizontal-rule">
</div>

<div class="bmc-uipath-detail-wrapper__loading-container" *ngIf="(isLoading$ | async)">
    <bz-loading size="xl" class="bmc-uipath-detail-wrapper__loading">
        {{'GLOBAL.LOADING_DATA' | translate}}
    </bz-loading>
</div>

<bots-empty *ngIf="!(uiPathConnection$ | async) && !(isLoading$ | async)">
    {{'RPA_BOTS.EMPTY_DETAIL' | translate}}
</bots-empty>
